import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5438_10001)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5 23.92C5.89471 23.92 0.540039 18.5653 0.540039 11.96C0.540039 5.35468 5.89471 0 12.5 0C19.1054 0 24.46 5.35468 24.46 11.96C24.46 18.5653 19.1054 23.92 12.5 23.92ZM12.4996 9.30401L8.84265 15.483H16.1565L12.4996 9.30401ZM12.4996 4.56166L12.5 4.56091H12.4991L12.4996 4.56166ZM4.5 18.0791L12.4996 4.56166L20.5 18.0791H4.5Z"
        fill="#ECEDEE"
      />
    </g>
    <defs>
      <clipPath id="clip0_5438_10001">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)
